/**
 * JSON utility module for symbol
 */
define("tmds/symbols/utils", [
	"../validator"
], function(validator) {
	"use strict";
	
	/**
	 * convert line style to d3 stroke-dasharray
	 * @param lineStyle {String}
	 * @returns {String} d3 stroke-dasharray in string
	 */
	function toDashArray(lineStyle) {
		var converter = {
			"dash": "10,10",
			"dashdotdot": "20,10,5,5,5,10",
			"dotted": "5,5",
			"solid": ""
		};
		
		if(converter[lineStyle] == undefined)
			throw new Error('Invalid line style ' + lineStyle + ' passed.');
		
		return converter[lineStyle];
	}
	
	/**
	 * convert hexadecimal color value to RGBA array
	 * @param value {String}
	 * @returns {Array} [R, G, B, A]
	 */
	function _hexToArray(value) {
		
		var _arr = [],
			_max = value.length == 4 ? 3 : 6,
			_step = value.length == 4 ? 1 : 2;
		
		for(var i = 1; i < _max; i += _step) {
			
			_arr.push(parseInt(value.substr(i, _step), 16));
		}
		
		_arr.push(1);
		
		return _arr;
	}
	
	/**
	 * convert RGB color value to RGBA array
	 * @param value {String}
	 * @returns {Array} [R, G, B, A]
	 */
	function _rgbToArray(value) {
		
		var _arr = value.substring(4, value.length-1).split(',');
		
		for(var i = 0; i < 3; i++) {
			
			_arr[i] = _arr[i].indexOf('%') != -1 ? (255 * parseInt(_arr[i]) / 100) : parseInt(_arr[i]);
		}
		
		_arr.push(1);
		
		return _arr;
	}
	
	/**
	 * convert RGBA color value to RGBA array
	 * @param value {String}
	 * @returns {Array} [R, G, B, A]
	 */
	function _rgbaToArray(value) {
		
		var _arr = value.substring(5, value.length-1).split(',');
		
		for(var i = 0; i < 3; i++) {
			
			_arr[i] = _arr[i].indexOf('%') != -1 ? (255 * parseInt(_arr[i]) / 100) : parseInt(_arr[i]);
		}
		
		_arr[i] = Number(_arr[i] || 1);
		
		return _arr;
	}
	
	/**
	 * validate and then convert color value to RGBA array
	 * @param color {String}
	 * @returns {Array} [R, G, B, A]
	 */
	function toColorArray(color) {
		
		var colorArr = [];
		
		// Removes spaces and convert to lower-case if the provided "color" is string
		if(validator.isString(color)) {
			
			color = color.replace(/\s/g, '');
		
			color = color.toLowerCase();
		}
		
		// If its already an Array
		if(validator.isColorArray(color)) {
			
			colorArr = color;
			
			if(colorArr.length == 3) colorArr.push(1);
		}
		// If its Hexadecimal color
		else if(validator.isHexColor(color)) {
			
			colorArr = _hexToArray(color);
		}
		// If its RGB color
		else if(validator.isRgbColor(color)) {
			
			colorArr = _rgbToArray(color);
		}
		// If its RGBA color
		else if(validator.isRgbaColor(color)) {
			
			colorArr = _rgbaToArray(color);
		}
		// Otherwise do not set color
		else {
			return false;
		}
		
		return colorArr;
	}
	
	var utils = {
		'toDashArray' : toDashArray,
		'toColorArray' : toColorArray
	};
	
	return utils;
});